import React from 'react'
import { Flex, Typography } from 'antd'

interface StepHeadingProps {
  title: React.ReactNode
  description?: React.ReactNode
  // Optional right-aligned content on the title row (e.g. "target → sibling").
  extra?: React.ReactNode
}

// Shared title + description block for every wizard step, so spacing and type scale stay identical.
const StepHeading: React.FC<StepHeadingProps> = ({ title, description, extra }) => (
  <>
    <Flex justify="space-between" align="baseline" style={{ marginBottom: 4 }}>
      <Typography.Title level={5} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
      {extra}
    </Flex>
    {description && (
      <Typography.Text type="secondary" style={{ fontSize: 13, display: 'block', marginBottom: 16 }}>
        {description}
      </Typography.Text>
    )}
  </>
)

export default StepHeading
